import { Routes } from '@angular/router';
import { AuthGuard } from './guards/auth.guard';

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () => import('./components/login/login.component').then(m => m.LoginComponent)
  },
  {
    path: '',
    loadComponent: () => import('./components/layout/layout.component').then(m => m.LayoutComponent),
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        redirectTo: '/dashboard',
        pathMatch: 'full'
      },
      {
        path: 'dashboard',
        loadComponent: () => import('./components/dashboard/dashboard.component').then(m => m.DashboardComponent)
      },
          {
            path: 'users',
            loadChildren: () => import('./modules/users/users.module').then(m => m.UsersModule)
          },
          {
            path: 'audit',
            loadChildren: () => import('./modules/audit/audit.module').then(m => m.AuditModule)
          },
          {
            path: 'payrolls',
            loadChildren: () => import('./modules/payrolls/payrolls.module').then(m => m.PayrollsModule)
          },
          {
            path: 'nid-search',
            loadChildren: () => import('./modules/nid-search/nid-search.module').then(m => m.NidSearchModule)
          },
          {
            path: 'feedback',
            loadChildren: () => import('./modules/feedback/feedback.module').then(m => m.FeedbackModule)
          },
          {
            path: 'email',
            loadChildren: () => import('./modules/email/email.module').then(m => m.EmailModule)
          },
          {
            path: 'sms',
            loadChildren: () => import('./modules/sms/sms.module').then(m => m.SmsModule)
          },
          {
            path: 'payments',
            loadChildren: () => import('./modules/payments/payments.module').then(m => m.PaymentsModule)
          },
          {
            path: 'scheduler',
            loadChildren: () => import('./modules/scheduler/scheduler.module').then(m => m.SchedulerModule)
          },
          {
            path: 'es-indexes',
            loadChildren: () => import('./modules/es-index/es-index.module').then(m => m.EsIndexModule)
          },
          {
            path: 'apps',
            loadChildren: () => import('./modules/apps/apps.module').then(m => m.AppsModule)
          },
      {
        path: 'workspaces',
        loadComponent: () => import('./components/placeholder/placeholder.component').then(m => m.PlaceholderComponent)
      },
      {
        path: 'settings',
        loadComponent: () => import('./components/placeholder/placeholder.component').then(m => m.PlaceholderComponent)
      },
      {
        path: 'profile',
        loadComponent: () => import('./components/placeholder/placeholder.component').then(m => m.PlaceholderComponent)
      }
    ]
  },
  {
    path: '**',
    redirectTo: '/dashboard'
  }
];
